import {useMutation, useQuery, useQueryClient} from "react-query";
import {request} from "../BaseApi";
import {ResourceTypeDto} from "../Models/ResourceTypeDto";

export const ADMIN_RESOURCE_TYPE_CACHE_KEY = "ADMIN_RESOURCE_TYPE_CACHE_KEY";
export const useResourceTypes = () => {
    return useQuery([ADMIN_RESOURCE_TYPE_CACHE_KEY], async () => {
        return await request<ResourceTypeDto[]>({
            url: `/admin/resourceTypes`,
            method: 'GET',
        })
    })
}

export const useSaveResourceType = () => {

    const queryClient = useQueryClient();

    return useMutation(async (resourceType: ResourceTypeDto): Promise<ResourceTypeDto> => {
        if (resourceType.id) {
            return await request<ResourceTypeDto>({
                url: `/admin/resourceTypes/${resourceType.id}`,
                method: 'PUT',
                data: resourceType
            })
        } else {
            return await request<ResourceTypeDto>({
                url: `/admin/resourceTypes`,
                method: 'POST',
                data: resourceType
            })
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries([ADMIN_RESOURCE_TYPE_CACHE_KEY]);
        }
    })
}

export const useMoveResourceType = () => {

    const queryClient = useQueryClient();

    return useMutation(async ({resourceType, direction}: {resourceType: ResourceTypeDto, direction: 'Up' | 'Down'}): Promise<ResourceTypeDto> => {
        return await request<ResourceTypeDto>({
            url: `/admin/resourceTypes/${resourceType.id}/move/${direction}`,
            method: 'PUT',
        })
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries([ADMIN_RESOURCE_TYPE_CACHE_KEY]);
        }
    })
}

export const useCleanResourceType = () => {
    const queryClient = useQueryClient();

    return useMutation(async (resourceType: ResourceTypeDto) => {
            return await request({
                url: `/admin/resourceTypes/clean/${resourceType.id}`,
                method: 'POST',
            })
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries([ADMIN_RESOURCE_TYPE_CACHE_KEY]);
            }
        }
    )
}

export const useDeleteResourceType = () => {
    const queryClient = useQueryClient();

    return useMutation(async (resourceType: ResourceTypeDto) => {
            return await request({
                url: `/admin/resourceTypes/${resourceType.id}`,
                method: 'DELETE',
            })
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries([ADMIN_RESOURCE_TYPE_CACHE_KEY]);
            }
        }
    )
}

export const useDeleteResourceTypeBulk = () => {
    const queryClient = useQueryClient();

    return useMutation(async (ids: string[]) => {
            return await request({
                url: `/admin/resourceTypes/bulkDelete`,
                method: 'POST',
                data: ids
            })
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries([ADMIN_RESOURCE_TYPE_CACHE_KEY]);
            }
        }
    )
}
